module.exports = __webpack_public_path__ + "media/refer_friend/your-friends-register_175x175_@2x-073f5550.png";